<!--
画面内にメッセージ（エラー、情報、成功）通知を表示するモジュール
@props
  errors : 通知として表示するメッセージ文字列の配列
  css_class : 通知がある場合に適用するCSSクラス
-->

<template>
  <v-row v-if="hasError" :class="css_class">
    <v-col cols="12" v-for="item in errors" :key="item.key">
      <template v-if="item.type == 'error'">
        <v-alert type="error" dense outlined>{{ item.message }}</v-alert>
      </template>
      <template v-if="item.type == 'success'">
        <v-alert type="success" dense outlined>{{ item.message }}</v-alert>
      </template>
      <template v-if="item.type == 'info'">
        <v-alert type="info" dense outlined>{{ item.message }}</v-alert>
      </template>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ["errors", "css_class"],
  computed: {
    hasError() {
      return this.errors?.length != 0;
    },
  },
};
</script>

<style></style>
